import { useState, useEffect, useCallback } from 'react';
import { getTournament } from '@/api/TournamentManagement/tournamentApi';
import type { TournamentView } from '@/models/tournament';

export function useTournament(id: number) {
  const [data, setData] = useState<TournamentView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!id) {
      setData(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await getTournament(id);
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
